import { useEffect, useRef, Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import OptionA from "@/optiona/OptionA";
import OptionAArchive from "@/optionaArchive/OptionA";
import OptionB from "@/optionb/OptionB";
import Switcher from "@/components/Switcher";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  render() {
    if (this.state.err) {
      return (
        <div className="min-h-screen grid place-items-center bg-navy text-cream font-bodya p-8 text-center">
          <p>Something went wrong on our side — please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function SmoothScroll() {
  const lenisRef = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <Routes>
          <Route path="/" element={<OptionA />} />
          <Route path="/archive-a" element={<OptionAArchive />} />
          <Route path="/option-b" element={<OptionB />} />
          <Route path="*" element={<OptionA />} />
        </Routes>
        <Switcher />
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
